import * as React from 'react'

import { ArrowDownIcon, ArrowUpIcon, Text } from '@buffer-mono/popcorn'
import { useReducedMotion } from 'motion/react'
import * as m from 'motion/react-m'

import styles from './NewItemsDivider.module.css'

import type { JSX } from 'react'

type NewItemsDividerProps = {
  /** The divider copy. */
  label: string
  /** Point the arrow at the new items when they sit below the divider. */
  arrowDown?: boolean
}

/**
 * Separates the items the user hasn't caught up with from the settled list.
 * Rendered as an `<li>` so the surrounding `<ol>` stays valid. The entrance
 * animation is skipped under reduced-motion. Shared by the comments and
 * mentions lists.
 */
export const NewItemsDivider = ({
  label,
  arrowDown = false,
}: NewItemsDividerProps): JSX.Element => {
  const shouldReduceMotion = useReducedMotion()
  const Arrow = arrowDown ? ArrowDownIcon : ArrowUpIcon

  return (
    <m.li
      className={styles.divider}
      initial={shouldReduceMotion ? false : { opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.15, 0, 0.35, 1] }}
    >
      <Arrow className={styles.icon} aria-hidden />
      <Text size="sm" weight="medium" color="brand">
        {label}
      </Text>
      <span className={styles.line} aria-hidden />
    </m.li>
  )
}
